var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-client-table", {
        attrs: {
          data: _vm.periods,
          columns: _vm.columns,
          options: _vm.options,
        },
        scopedSlots: _vm._u([
          {
            key: "price",
            fn: function (props) {
              return _c("div", {
                domProps: { innerHTML: _vm._s(props.row.price_html) },
              })
            },
          },
          {
            key: "tour_name",
            fn: function (props) {
              return _c("div", {}, [
                _c("a", { attrs: { href: props.row.tour_permalink } }, [
                  _vm._v(_vm._s(props.row.tour_name)),
                ]),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }